import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import useTenantGetHook from "../../customHooks/useTenantControlGetHook";

const CreateBranchInvoiceComponent = loadable(
  () => import("../../components/BranchInvoice/CreateBranchInvoice")
);

const CreateBranchInvoice = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["branch-invoice"],
    navigateURL: "/",
  });

  const { mutateAsync: draftSaveAsync, isPostLoading: isDraftSaveLoading } =
    usePostHook({
      queryKey: ["orders"],
      navigateURL: "",
    });

  const { data: currentUser, isLoading: isGettingUserInfo } = useGetHook({
    url: `${APIS.USER}me/`,
    queryKey: ["current-user"],
    params: {},
  });

  const parseCombinedOrders = (searchParams) => {
    const editedRaw = searchParams.get("editedOrders");
    const selectedRaw = searchParams.get("selectedItems");
    const selectedIds = new Set();
    if (selectedRaw) {
      selectedRaw.split(",").forEach((id) => {
        selectedIds.add(id);
      });
    }

    const updatesMap = new Map();

    if (editedRaw) {
      editedRaw.split(",").forEach((entry) => {
        const [idField, value] = entry.split("=");
        const [id, field] = idField.split(":");

        if (selectedIds.has(id)) {
          if (!updatesMap.has(id)) {
            updatesMap.set(id, { id });
          }
          updatesMap.get(id)[field] = Number(value);
        }
      });
    }
    selectedIds.forEach((id) => {
      if (!updatesMap.has(id)) {
        updatesMap.set(id, { id });
      }
    });

    return Array.from(updatesMap.values());
  };
  const parseEditedOrders = (searchParams) => {
    const editedRaw = searchParams.get("editedOrders");

    const updatesMap = new Map();

    if (editedRaw) {
      editedRaw
        .split(",")
        .filter((entry) => entry && entry !== "null") // Ignore empty or "null"
        .forEach((entry) => {
          const [idField, value] = entry.split("=");
          if (!idField || !value) return; // Skip invalid entries

          const [id, field] = idField.split(":");
          if (!id || !field) return; // Skip invalid entries

          if (!updatesMap.has(id)) {
            updatesMap.set(id, { id });
          }
          updatesMap.get(id)[field] = Number(value);
        });
    }

    return Array.from(updatesMap.values());
  };

  const [searchParams, setSearchParms] = useSearchParams();

  const handleCreate = async (values: any, setError: any) => {
    const dataToPost = parseCombinedOrders(searchParams);
    const url = `${APIS.BRANCH_INVOICE}`;
    const dates = values?.created__range
      ? values?.created__range
          .split(",")
          .map((datetime) => datetime.split("T")[0])
      : null;
    const formData = {
      from_branch: values?.from_branch,
      orders: dataToPost,
      date_range: dates,
      to_branch: values?.to_branch,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveDraft = async () => {
    const dataToPost = parseEditedOrders(searchParams);
    const url = `${APIS.INVOICE_ORDER}update/`;
    let formData = {
      orders: dataToPost,
    };
    try {
      const res = await draftSaveAsync({ url, formData, setError: () => {} });
      // if (res?.status === 200) {
      //   searchParams.delete("editedOrders");
      //   setSearchParms(searchParams);
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const { data, isLoading: isPermissionListLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data && data?.custom_permissions;
  return (
    !isGettingUserInfo && (
      <>
        <div
          className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
        >
          <CreateIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>
            Create Branch Statement
          </span>
        </div>
        <CreateBranchInvoiceComponent
          handleCreate={handleCreate}
          isLoading={isPostLoading}
          currentUser={currentUser}
          userPermissions={permissionsLists}
          isDraftSaveLoading={isDraftSaveLoading}
          handleSaveDraft={handleSaveDraft}
        />
      </>
    )
  );
};

export default CreateBranchInvoice;
